module.exports = __webpack_public_path__ + "f66ceebd66b1647f0cbde5b0f9bb0e2d.svg";